module.exports = __webpack_public_path__ + "img/diabolical_dr_z_tablet.9fcc2076.jpg";